import React from 'react';
import Numeral from 'numeral';
import _classNames from 'classnames';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import StarRating from 'components/Rating';
import { getUserRatingAndCount } from 'components/UserAndExpertRating/utils';
import Colors from 'utils/colors';
import RatingTooltip from './RatingTooltip';

const reverseTypeMap = {
  Apps: 'app',
  Books: 'book',
  Podcasts: 'podcast',
  Videos: 'video',
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  text: {
    ...theme.typography.pxSmall,
    fontSize: 10,
    lineHeight: 1,
    marginLeft: 4,
    marginRight: 4,
  },
  total: {
    color: Colors.gray,
  },
  iconWrapper: {
    display: 'flex !important',
  },
  padded: {
    paddingLeft: 10,
  },
  whiteText: {
    color: '#fff',
  },
  icon: {
    height: 12,
    width: 12,
  },
}));

function Rating({ data, type }) {
  const classes = useStyles();

  const {
    avgRating,
    calculatedAverageRating,
    calculatedExpertRating,
    slug,
    className,
  } = data;

  const finalAvgRating = calculatedAverageRating || avgRating;

  const {
    rating: userFinalRating,
    count: userFinalCount,
  } = getUserRatingAndCount(data, reverseTypeMap[type] || type);

  return (
    <div className={_classNames(classes.root, className)}>
      <StarRating name={`${slug}-rating`} value={finalAvgRating} />
      <Typography className={classes.text}>
        {Numeral(finalAvgRating).format('0.0')}
      </Typography>
      <RatingTooltip
        expert={calculatedExpertRating}
        user={userFinalRating}
        userCount={userFinalCount}
        slug={slug}
      />
    </div>
  );
}

Rating.propTypes = {
  data: PropTypes.object,
  type: PropTypes.string,
};

export default Rating;
